import { render } from "./MenuItem.vue?vue&type=template&id=2f18874e"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"
script.render = render

export default script